/**
 * Utilidades modulares para procesamiento y visualización de etiquetas (tags) de inmuebles.
 */

export const normalizePropertyTags = (rawTag?: any, rawTags?: any): string[] => {
  const combined: string[] = [];

  const extract = (val: any) => {
    if (!val) return;
    if (Array.isArray(val)) {
      val.forEach((item) => extract(item));
    } else if (typeof val === 'string') {
      if (val.includes(',') || val.includes(';')) {
        val.split(/[,;]/).forEach((part) => {
          const trimmed = part.trim();
          if (trimmed) combined.push(trimmed);
        });
      } else {
        const trimmed = val.trim();
        if (trimmed) combined.push(trimmed);
      }
    }
  };

  extract(rawTag);
  extract(rawTags);

  // Filtrar elementos vacíos y remover duplicados
  return Array.from(new Set(combined.filter((item) => item.length > 0)));
};

const TAG_COLOR_PALETTES = [
  'bg-sky-50 text-sky-700 border-sky-200/80 hover:bg-sky-100',
  'bg-emerald-50 text-emerald-700 border-emerald-200/80 hover:bg-emerald-100',
  'bg-amber-50 text-amber-800 border-amber-200/80 hover:bg-amber-100',
  'bg-purple-50 text-purple-700 border-purple-200/80 hover:bg-purple-100',
  'bg-indigo-50 text-indigo-700 border-indigo-200/80 hover:bg-indigo-100',
  'bg-rose-50 text-rose-700 border-rose-200/80 hover:bg-rose-100',
];

export const getTagBadgeClass = (tag: string, index: number = 0): string => {
  let hash = 0;
  for (let i = 0; i < tag.length; i++) {
    hash = (hash + tag.charCodeAt(i) * (i + 1)) % TAG_COLOR_PALETTES.length;
  }
  const chosenIndex = (hash + index) % TAG_COLOR_PALETTES.length;
  return TAG_COLOR_PALETTES[chosenIndex];
};

const SOLID_CARD_BADGE_COLORS = [
  'bg-teal-600',
  'bg-sky-600',
  'bg-indigo-600',
  'bg-violet-600',
  'bg-emerald-600',
  'bg-fuchsia-600',
];

export const getTagCardBadgeColor = (tag: string, index: number = 0): string => {
  let hash = 0;
  for (let i = 0; i < tag.length; i++) {
    hash = (hash + tag.charCodeAt(i) * (i + 1)) % SOLID_CARD_BADGE_COLORS.length;
  }
  const chosenIndex = (hash + index) % SOLID_CARD_BADGE_COLORS.length;
  return SOLID_CARD_BADGE_COLORS[chosenIndex];
};

